import { Button, Kind } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { ContentBlockTypes } from 'api/landingPageTheme'
import ConfirmModal from 'components/ConfirmModal'
import { buildTranslate } from 'locales'
import React, { useState } from 'react'
import Title from './Title'

const t = buildTranslate('cms.content.app_home_page.content.block_item')
const tBlocks = buildTranslate('cms.components.blocks')

type Props = {
  type: ContentBlockTypes
  onEdit: () => void
  onRemove?: () => void
}

const Header = ({ type, onEdit, onRemove }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleRemoveClick = () => {
    setIsModalOpen(true)
  }

  const handleConfirmRemove = () => {
    onRemove?.()
    setIsModalOpen(false)
  }

  return (
    <>
      <ConfirmModal
        title={tBlocks('delete_modal.title', { type: 'block' })}
        description={tBlocks('delete_modal.description', { type: 'block' })}
        confirmText={tBlocks('delete_modal.confirm', { type: 'block' })}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirmRemove}
      />
      <div className="d-flex align-items-center justify-content-between mb-s">
        <Title type={type} />
        <div className="d-flex">
          {onRemove && (
            <Button
              onClick={handleRemoveClick}
              kind={Kind.MINIMAL}
              className="p-0"
            >
              <Text.BodyText3
                tag="span"
                className="ml-xs mb-0"
                color="cayenne50"
              >
                {t('remove')}
              </Text.BodyText3>
            </Button>
          )}
          <Button onClick={onEdit} kind={Kind.MINIMAL} className="p-0 ml-xs">
            <Text.BodyText3 tag="span" className="ml-xs mb-0" color="primary">
              {t('edit')}
            </Text.BodyText3>
          </Button>
        </div>
      </div>
    </>
  )
}

export default Header
